import React, { useState } from 'react';
import PrivacyPolicyModal from './PrivacyPolicyModal';

const Footer = () => {
  const currentYear = new Date().getFullYear();
  const [showPrivacyPolicy, setShowPrivacyPolicy] = useState(false);

  return (
    <>
      <footer className="bg-white border-t-4 mt-12" style={{ borderColor: '#E78E42' }}>
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            {/* About Section */}
            <div>
              <h3 className="text-lg font-bold mb-3" style={{ color: '#0A3C80' }}>
                About This Project
              </h3>
              <p className="text-gray-600 text-sm">
                Research on EU solar manufacturing competitiveness, exploring optimization scenarios
                for photovoltaic manufacturing across Europe.
              </p>
            </div>

          {/* Partners Section */}
          <div>
            <h3 className="text-lg font-bold mb-3" style={{ color: '#0A3C80' }}>
              Research Partners
            </h3>
            <div className="flex items-center gap-4">
              <a
                href="https://www.becquerelinstitute.eu/"
                target="_blank"
                rel="noopener noreferrer"
                className="hover:opacity-80 transition-opacity"
              >
                <img
                  src="/BI.png"
                  alt="Becquerel Institute"
                  className="h-28 object-contain"
                />
              </a>
              <a
                href="https://acap.org.au/"
                target="_blank"
                rel="noopener noreferrer"
                className="hover:opacity-80 transition-opacity"
              >
                <img
                  src="/ACAP.png"
                  alt="Australian Centre for Advanced Photovoltaics"
                  className="h-12 object-contain"
                />
              </a>
            </div>
          </div>

          {/* Contact Section */}
          <div>
            <h3 className="text-lg font-bold mb-3" style={{ color: '#0A3C80' }}>
              Contact
            </h3>
            <p className="text-gray-600 text-sm">
              For inquiries about this research, please contact the research team
              at the respective institutions.
            </p>
          </div>
        </div>

        {/* Copyright and License */}
        <div className="mt-8 pt-6 border-t border-gray-200">
          <div className="flex flex-col md:flex-row items-center justify-between gap-4">
            {/* Copyright */}
            <div className="text-center md:text-left">
              <p className="text-gray-600 text-sm">
                © {currentYear} Becquerel Institute & ACAP
              </p>
              <p className="text-gray-500 text-xs mt-1">
                This tool is provided for research and educational purposes.
              </p>
              <button
                onClick={() => setShowPrivacyPolicy(true)}
                className="text-blue-600 hover:text-blue-800 text-xs mt-1 underline transition-colors"
              >
                Privacy Policy & GDPR
              </button>
            </div>

            {/* License */}
            <div className="text-center md:text-right">
              <a
                href="https://creativecommons.org/licenses/by-sa/4.0/"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center gap-2 text-gray-600 hover:text-gray-800 transition-colors"
              >
                <img
                  src="https://licensebuttons.net/l/by-sa/4.0/88x31.png"
                  alt="CC BY-SA 4.0"
                  className="h-8"
                />
                <div className="text-left">
                  <p className="text-xs font-semibold">Licensed under</p>
                  <p className="text-xs">CC BY-SA 4.0</p>
                </div>
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>

    {/* Privacy Policy Modal */}
    <PrivacyPolicyModal
      isOpen={showPrivacyPolicy}
      onClose={() => setShowPrivacyPolicy(false)}
    />
  </>
  );
};

export default Footer;
